(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("header-footer-wix-statics", [], factory);
	else if(typeof exports === 'object')
		exports["header-footer-wix-statics"] = factory();
	else
		root["header-footer-wix-statics"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return 